import agentBreaksAPI from '../../api/agentBreaks';
import breakReasonsAPI from '../../api/breakReasons';

const state = {
  breakReasons: [],
  activeBreakSession: null,
  breakSessions: {
    data: null,
    summary: null,
    isFetching: false,
    error: null,
  },
};

const getters = {
  getBreakReasons: $state => $state.breakReasons,
  getActiveBreakSession: $state => $state.activeBreakSession,
  getBreakSessions: $state => $state.breakSessions,
  isOnBreak: $state => !!$state.activeBreakSession,
};

const mutations = {
  SET_BREAK_REASONS($state, reasons) {
    $state.breakReasons = reasons;
  },
  SET_ACTIVE_BREAK_SESSION($state, session) {
    $state.activeBreakSession = session;
  },
  SET_BREAK_SESSIONS($state, { data, summary }) {
    $state.breakSessions.data = data;
    $state.breakSessions.summary = summary;
    $state.breakSessions.error = null;
  },
  SET_BREAK_SESSIONS_ERROR($state, error) {
    $state.breakSessions.error = error;
  },
  SET_BREAK_SESSIONS_FETCHING($state, isFetching) {
    $state.breakSessions.isFetching = isFetching;
  },
};

const actions = {
  async fetchBreakReasons({ commit }) {
    try {
      const { data } = await breakReasonsAPI.get();
      commit('SET_BREAK_REASONS', data.data || []);
    } catch (error) {
      // silently fail - reasons list is non-critical
    }
  },

  async startBreak({ commit, dispatch, rootState }, { breakReasonId }) {
    const { data } = await agentBreaksAPI.startBreak({ breakReasonId });
    commit('SET_ACTIVE_BREAK_SESSION', data.data);
    // Update current user availability in auth store (mutation takes plain string)
    commit('auth/SET_CURRENT_USER_AVAILABILITY', 'on_break', { root: true });
    // Sync agents module so sidebar/presence indicators update immediately
    dispatch(
      'agents/updateSingleAgentPresence',
      {
        id: rootState.auth.currentUser.id,
        availabilityStatus: 'on_break',
      },
      { root: true }
    );
    return data;
  },

  async endBreak({ commit, dispatch, rootState }) {
    const { data } = await agentBreaksAPI.endBreak();
    commit('SET_ACTIVE_BREAK_SESSION', null);
    // Restore availability to online (mutation takes plain string)
    commit('auth/SET_CURRENT_USER_AVAILABILITY', 'online', { root: true });
    // Sync agents module so sidebar/presence indicators update immediately
    dispatch(
      'agents/updateSingleAgentPresence',
      {
        id: rootState.auth.currentUser.id,
        availabilityStatus: 'online',
      },
      { root: true }
    );
    return data;
  },

  async fetchBreakSessions({ commit }, params = {}) {
    commit('SET_BREAK_SESSIONS_FETCHING', true);
    try {
      const { data } = await agentBreaksAPI.getSessions(params);
      commit('SET_BREAK_SESSIONS', {
        data: data.data || [],
        summary: data.summary || {},
      });
    } catch (err) {
      commit('SET_BREAK_SESSIONS_ERROR', err.message || 'Failed to fetch');
    } finally {
      commit('SET_BREAK_SESSIONS_FETCHING', false);
    }
  },

  clearActiveBreakSession({ commit }) {
    commit('SET_ACTIVE_BREAK_SESSION', null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
